import { Navigate, useLocation } from "react-router-dom";

/**
 * Maps old Thinkific /pages/{slug} URLs to new paths.
 * Falls back to homepage for unknown pages.
 */

const PAGE_MAP: Record<string, string> = {
  // Ausbildungen
  "ausbildung-musikpadagoge": "/ausbildung/fachkraft-musik",
  "fachkraft-fur-gitarre-im-padagogischen-handlungsfeld": "/ausbildung/fachkraft-gitarre",
  
  // Info-Seiten
  "termine": "/termine",
  "probemonat": "/preise",
  "kreativpaket": "/kurse",
  "ueber-uns": "/ueber-uns",
  "about": "/ueber-uns",
  "kontakt": "/kontakt",
  "impressum": "/impressum",
  "datenschutz": "/datenschutz",
  "agb": "/agb",
  "faq": "/hilfe",
  "hilfe": "/hilfe",
  "mitgliedschaft": "/preise",
  "pricing": "/preise",
  "preise": "/preise",
};

export default function LegacyPageRedirects() {
  const location = useLocation();
  
  // Extract slug from /pages/{slug}
  const match = location.pathname.match(/^\/pages\/([^/]+)/);
  const slug = match?.[1]?.toLowerCase();
  
  const target = slug ? (PAGE_MAP[slug] || "/") : "/";
  
  return <Navigate to={target} replace />;
}
